import React from 'react';
import { Helmet } from 'react-helmet';
import GlobalStyle from './GlobalStyle';
import Header from './Header';

export default ({ children }) => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href="/publio.png" />
		<title>PUBLIO</title>
      </Helmet>
      <div
        css={`
          max-width: 1200px;
          margin: 0 auto;
        `}
      >
        <GlobalStyle />
        <div
          css={`
            margin: 2rem;
            border-top: 1px solid black;
            border-left: 1px solid black;
          `}
        >
          <Header />
          {children}
        </div>
        <div
          css={`
              margin: 2rem;
              color: #444;
          `}
        >
        </div>
      </div>
    </React.Fragment>
  );
};
